import type { v2 } from '@deque/billing-service-client';
import { ProductSlugs } from '@deque/billing-utils';
import React from 'react';
import { Trans } from 'react-i18next';

import DQUPrePurchaseNotification from '~/common/components/DQUPrePurchaseNotification';
import LicenseBox from './LicenseBox';

export interface ReviewStepProps {
  productSlug: ProductSlugs;
  currentLicenseCount: number;
  licenseChangeCount: number;
  term: v2.SubscriptionPricing['interval'];
  price: number;
  totalLicensesValue: number;
  enterpriseName?: string;
}

const ReviewStep = ({
  productSlug,
  currentLicenseCount,
  licenseChangeCount,
  term,
  price,
  totalLicensesValue,
  enterpriseName
}: ReviewStepProps) => (
  <>
    <Trans parent="p">
      Take a moment to review the changes and ensure everything looks correct
      with the changes in your licenses.
    </Trans>
    <LicenseBox
      currentLicenseCount={currentLicenseCount}
      licenseChangeCount={licenseChangeCount}
      term={term}
      price={price}
      totalLicensesValue={totalLicensesValue}
      enterpriseName={enterpriseName}
    />
    {productSlug === ProductSlugs.dequeUniversity && (
      <>
        <br />
        <DQUPrePurchaseNotification />
      </>
    )}
  </>
);

export default ReviewStep;
